export default __webpack_public_path__ + "static/optical-adjustment-do-3566e404b59487a03643fe420c2b3bf4.png";